// extracted by mini-css-extract-plugin
module.exports = {"page":"Dashboards_page_2LLf2","noBorder":"Dashboards_noBorder_1E09V","box":"Dashboards_box_3L1aq","field":"Dashboards_field_2HJ3v"};